import React, { createContext, useCallback, useContext, useState } from 'react'
import { login as _login, checkToken, logout as _logout } from '../../../services/network'
import { setLocal, getLocal } from '../../../services/storage'
import { useNotificationContext } from './notificationContext'
import { useNavigate } from 'react-router-dom'
import { useEffect } from 'react'

export const UserContextClass = createContext(null)


export function UserContext({
  children
}) {
  const [user, setUser] = useState(false)
  const displayNotif = useNotificationContext()
  const navigate = useNavigate()

  const init = useCallback(async () => {

    let _user
    try {
      _user = await checkToken()
      console.log('token OK, setting user',  _user)
      await setLocal('token', _user.token)
      await setLocal('user', _user)
    } catch (e) {
      console.warn(e)
      navigate('/login')
      return
    }
    return _user

  }, [displayNotif])

  useEffect(() => {
    console.log('UserContext | useEffect[init]!')
    let timeout_id = setTimeout(async () => {
      let _user = await init()
      if (_user && timeout_id) {
        setUser(_user)
        // history.push('/preloader')
      }
    })
    return () => {
      clearTimeout(timeout_id)
      timeout_id = null
    }
    // let timeout_id = setTimeout(()=>init())  
    // return ()=>{clearTimeout(timeout_id)}
  }, [init])

  async function login(username, password) {
    try {
      // console.log('attempting login with username and pass', username, password)
      const _user = await _login(username, password)
      // console.log('logged in with user', _user)

      await setLocal('user', _user)
      setUser(_user)
      await setLocal('token', _user.token)
      setTimeout(async () => {
        // console.log('what is window', window)
        navigate('/preloader')
      }, 1500)

    } catch (e) {
      console.debug('caught error in logIn', e)
      setLocal('user', null)
      setLocal('token', null)
      setUser(false)
      displayNotif('warning', `Login failed: ${e.message}`)
      throw e;
    }
  }

  async function logout() {
    await setLocal('user', null)
    await setLocal('token', null)
    await setLocal('lastSuccessfulPassword', null)
    await setLocal('lastSuccessfulUsername', null)
    setUser(false)
    // console.log('what is window', window)
    try{
      await _logout()
    }catch(e){
      console.warn('Failed logging out', e)
    }
    navigate('/login')
  }

  return (
    <UserContextClass.Provider value={{ user, login, logout, setUser }}>
      {children}
    </UserContextClass.Provider>
  )
}

export function useUserContext() {
  return useContext(UserContextClass)
}
